
<ng-container *ngIf="eventPageConfig">
  <div class='event-page' [ngClass]="eventPageClasses">
    <app-event-page-navbar [eventPageConfig]="eventPageConfig"></app-event-page-navbar>
    <div class="full-bg">
      <div class="container-fluid p-0 full-container">

        <ng-contaier *ngIf="eventPageData.isEventActive; else eventDeactivated">
          <app-event-page-header-type [eventPageConfig]="eventPageConfig" [eventPageData]="eventPageData"></app-event-page-header-type>

          <app-event-page-sponsors [eventPageConfig]="eventPageConfig" [eventPageData]="eventPageData"></app-event-page-sponsors>

          <ng-container *ngFor="let block of eventPageConfig.pageBlocks; let i = index;">
            <ng-container [ngSwitch]="block.type">

              <app-event-page-block-text *ngSwitchCase="1" [block]="block" [index]="i"></app-event-page-block-text>

              <app-event-page-block-faq *ngSwitchCase="2" [block]="block" [index]="i"></app-event-page-block-faq>

              <app-event-page-block-slides *ngSwitchCase="3" [block]="block" [index]="i"></app-event-page-block-slides>

              <app-event-page-block-campaign *ngSwitchCase="4" [eventPageConfig]="eventPageConfig" [block]="block" [index]="i"></app-event-page-block-campaign>

              <app-event-page-block-silent-auction *ngSwitchCase="5" [eventPageConfig]="eventPageConfig" [block]="block" [index]="i"></app-event-page-block-silent-auction>

              <app-event-page-block-live-auction *ngSwitchCase="6" [eventPageConfig]="eventPageConfig" [block]="block" [index]="i"></app-event-page-block-live-auction>

              <app-event-page-block-video *ngSwitchCase="7" [eventPageConfig]="eventPageConfig" [block]="block" [index]="i"></app-event-page-block-video>

              <app-event-page-block-image  *ngSwitchCase="8" [block]="block" [index]="i"></app-event-page-block-image>

            </ng-container>
          </ng-container>
        </ng-contaier>

        <ng-template #eventDeactivated>
          <div class="event-page-deactivated body-1">
            This event is not active at this time.
          </div>
        </ng-template>

        <app-event-page-organization-info *ngIf="eventPageConfig.orgInfo" [eventPageConfig]="eventPageConfig"></app-event-page-organization-info>
        
      </div>
    </div>
    <div id='footer' [class.abs]="!eventPageConfig.pageBlocks.length" class="event__footer">
      <a class="event__footer-link" target="_blank" [innerHTML]="eventPageConfig.orgInfo?.url" [href]="eventPageConfig.orgInfo?.url"></a>
    </div>
  </div>
</ng-container>

<app-mdb-toast ></app-mdb-toast>

<app-dialog></app-dialog>
